import { RestrictToHorizontalAxis } from '@dnd-kit/abstract/modifiers';
import { Feedback } from '@dnd-kit/dom';
import { RestrictToWindow } from '@dnd-kit/dom/modifiers';

export const boardColumnSortableModifiers = [RestrictToHorizontalAxis, RestrictToWindow];
export const boardColumnSortablePlugins = [
    Feedback.configure({
        feedback: 'clone',
    }),
];
